// ScrollToTopOnRouteChange.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // أو "instant" لو عايز بدون حركة
    });
  }, [pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;
